// CMS API Helpers for BRDR. LORENZEN. SKÆRBÆK ApS

const BASE_URL = "https://api.dev.auxo.dk/public";

/**
 * Henter alle emner fra en bestemt CMS-kollektion.
 * @param {string} collectionName Navnet på kollektionen (f.eks. 'pages', 'services', 'galleries')
 * @returns {Promise<Array>} Array af indholdsemner
 */
export async function fetchCollection(collectionName) {
  try {
    const response = await fetch(`${BASE_URL}/content/${collectionName}`, {
      headers: {
        "Accept": "application/json"
      }
    });
    if (!response.ok) {
      throw new Error(`Kunne ikke hente ${collectionName}: ${response.statusText}`);
    }
    const data = await response.json();
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.warn(`CMS Fetch Error for ${collectionName}, bruger fallback data:`, error);
    return [];
  }
}

/**
 * Henter en enkelt side baseret på dens slug_id.
 * @param {string} slugId Siden's slug_id (f.eks. 'forside', 'vaerksted', 'om-os')
 * @returns {Promise<Object|null>} Siden's data eller null
 */
export async function fetchPageBySlug(slugId) {
  const pages = await fetchCollection("pages");
  const page = pages.find((p) => p.slug_id === slugId);
  return page || null;
}

/**
 * Henter en enkelt ydelse baseret på dens slug_id.
 * @param {string} slugId Ydelsens slug_id (f.eks. 'sommerdaek', 'serviceeftersyn')
 * @returns {Promise<Object|null>} Ydelsens data eller null
 */
export async function fetchServiceBySlug(slugId) {
  const services = await fetchCollection("services");
  const service = services.find((s) => s.slug_id === slugId);
  return service || null;
}

/**
 * Henter et galleri baseret på dets slug_id.
 * @param {string} slugId Galleriets slug_id (f.eks. 'vaerksted', 'daek')
 * @returns {Promise<Object|null>} Galleriets data eller null
 */
export async function fetchGalleryBySlug(slugId) {
  const galleries = await fetchCollection("galleries");
  const gallery = galleries.find((g) => g.slug_id === slugId);
  return gallery || null;
}
